<app-shared-action-bar
  [displayActionSectionBar]="true"
  [saveReady]="false"
  [undoReady]="false"
  alternativeBackDestination="/settings">
</app-shared-action-bar>

<div class="templates-page container p-4">
  <p-confirmpopup key="eventTemplateDelete" styleClass="confirm-popup-danger">
    <ng-template pTemplate="headless" let-confirmation>
      <div class="confirm-popup-wrapper flex items-start gap-3">
        <i class="pi pi-exclamation-triangle text-danger-base text-xl"></i>
        <div class="flex flex-col gap-3 w-full">
          <div>
            <p class="font-semibold text-sm">{{confirmation?.header || 'Remove template'}}</p>
            <p class="text-sm text-grey-700">{{confirmation?.message || 'Are you sure you want to remove this template?'}}</p>
          </div>
          <div class="flex gap-2 justify-end w-full">
            <button pButton type="button" class="btn-inverse btn-compact btn-xs confirm-keep-btn" (click)="onConfirmReject(confirmation)">
              <i class="pi pi-undo mr-1"></i>
              <span>Keep</span>
            </button>
            <button pButton type="button" class="btn-negative btn-compact btn-xs confirm-remove-btn" (click)="onConfirmAccept(confirmation)">
              <i class="pi pi-trash mr-1"></i>
              <span>Remove</span>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-confirmpopup>
  <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between mb-4">
    <div>
      <p class="text-xs uppercase tracking-wide text-grey-700 mb-1">Events</p>
      <h1 class="text-2xl font-semibold leading-tight">Event Templates</h1>
      <p class="text-sm text-grey-800">Manage the templates available when creating new events.</p>
    </div>
    <div class="actions-row">
      <button pButton type="button" label="New Template" icon="pi pi-plus" class="p-button-sm" (click)="newTemplate()"></button>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="flex items-center justify-between mb-3">
      <h2 class="text-xl font-semibold">Existing templates</h2>
    </div>
    <p-table [value]="templates" [loading]="loading" responsiveLayout="scroll" class="templates-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Main {{ 'audit' | customerTerm }}</th>
          <th>Locations</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-template>
        <tr class="template-row">
          <td>{{ template.TemplateName || template.WorkflowName }}</td>
          <td>{{ template.MainAuditName || template.MainAuditID }}</td>
          <td>{{ template.LocationIDs?.length ? (template.LocationIDs.length + ' location(s)') : 'All Locations' }}</td>
          <td class="row-actions">
            <button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-sm" (click)="editTemplate(template)"></button>
            <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-sm remove-btn" (click)="deleteTemplate(template, $event)"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
